<app-widget [widget-meta]="this.data"
  externalLink="https://a.kenan-flagler.unc.edu/Applications/Students/?view=Leadership"
  externalLinkText="Visit Points Tracking"
  showHelp="true">
  @if (pointsTrackingService.trackingGroups$ | async; as groups) {
    <div>
      @for (group of groups; track group) {
        <div>
          <div class="row">
            <div class="col-md-12 text-center">
              <span class="points-tracking__title">{{ group.Title }}</span><br />
              <span class="points-tracking__message">{{ group.completionMessage }}</span><br />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="chart-inline-group">
                <!-- Easy pie chart was removed, please replace this with google charts-->
                <!--<easy-pie-chart class="easyPieChart" [percent]="group.overallPercentComplete" [options]="overalloptions"></easy-pie-chart>
                <easy-pie-chart class="easyPieChart" [percent]="group.requiredPercentComplete" [options]="requiredoptions"></easy-pie-chart>-->
              </div>
            </div>
            <div class="col-md-12 text-center">
              <i class="fa fa-fw fa-circle points-tracking__overall"></i> <span class="text-muted small">{{group.overallPercentComplete}}% Overall</span> &nbsp;
              <i class="fa fa-fw fa-circle points-tracking__required"></i> <span class="text-muted small">{{group.requiredPercentComplete}}% Required</span>
            </div>
          </div>
        </div>
      }
      @if (groups.length <= 0) {
        <div>
          <div class="row">
            <div class="col-md-12">
              <span class="points-tracking__none">No Points Tracking Groups</span><br />
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="widget-loading text-center">
      <i class="fas fa-circle-notch fa-spin"></i>
    </div>
  }
</app-widget>
